import React, { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { Bars3Icon, BellIcon } from '@heroicons/react/24/outline';
import { Menu, Transition } from '@headlessui/react';
import { Fragment } from 'react';

const Header = ({ onMenuClick }) => {
  const { user, logout } = useAuth();
  const [notifications] = useState([]);

  return (
    <div
      className="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 border-b bg-white/80 backdrop-blur px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8 relative"
      style={{
        borderColor: 'rgba(217, 119, 6, 0.35)',
        backgroundImage: 'linear-gradient(180deg, rgba(252,211,77,0.95) 0%, rgba(245,158,11,0.95) 45%, rgba(217,119,6,0.95) 100%)'
      }}
    >
      {/* Same jewelry pattern as sidebar */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 opacity-25"
        style={{
          backgroundImage:
            `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160' viewBox='0 0 160 160'%3E%3Cg fill='none' stroke='%2392400e' stroke-opacity='0.35' stroke-width='1.2'%3E%3Cpath d='M80 10l20 30-20 30-20-30z'/%3E%3Ccircle cx='120' cy='120' r='16'/%3E%3Cpath d='M20 120c10-8 22-8 32 0 10 8 22 8 32 0'/%3E%3Cpath d='M100 20c8 6 12 14 12 24'/%3E%3C/g%3E%3C/svg%3E")`,
          backgroundSize: '200px 200px',
        }}
      />
      {/* Mobile menu button */}
      <button
        type="button"
        className="-m-2.5 p-2.5 text-primary-700 lg:hidden"
        onClick={onMenuClick}
      >
        <span className="sr-only">Open sidebar</span>
        <Bars3Icon className="h-6 w-6" aria-hidden="true" />
      </button>

      {/* Separator */}
      <div className="h-6 w-px bg-gray-200 lg:hidden" aria-hidden="true" />

      <div className="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
        <div className="relative flex flex-1"></div>
        
        <div className="flex items-center gap-x-4 lg:gap-x-6">
          {/* Notifications */}
          <button
            type="button"
            className="-m-2.5 p-2.5 text-primary-700/70 hover:text-primary-700"
          >
            <span className="sr-only">View notifications</span>
            <BellIcon className="h-6 w-6" aria-hidden="true" />
            {notifications.length > 0 && (
              <span className="absolute -top-1 -right-1 h-4 w-4 rounded-full bg-red-500 text-xs text-white flex items-center justify-center">
                {notifications.length}
              </span>
            )}
          </button>

          {/* Separator */}
          <div className="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-200" aria-hidden="true" />

          {/* Profile dropdown */}
          <Menu as="div" className="relative z-[9999]">
            <Menu.Button className="-m-1.5 flex items-center p-1.5 relative z-[9999]">
              <span className="sr-only">Open user menu</span>
              <div className="h-8 w-8 rounded-full bg-white/90 flex items-center justify-center shadow border border-primary-200">
                <span className="text-sm font-bold text-primary-800">
                  {user?.full_name?.charAt(0) || 'U'}
                </span>
              </div>
              <span className="hidden lg:flex lg:items-center">
                <span className="ml-4 text-sm font-semibold leading-6 text-primary-800" aria-hidden="true">
                  {user?.full_name || 'User'}
                </span>
              </span>
            </Menu.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="absolute right-0 z-[9999] mt-2.5 w-32 origin-top-right rounded-md bg-white py-2 shadow-2xl ring-1 ring-gray-900/20 focus:outline-none border border-gray-200" style={{ zIndex: 9999, position: 'fixed', top: '60px', right: '20px' }}>
                <Menu.Item>
                  {({ active }) => (
                    <button
                      className={`${
                        active ? 'bg-primary-50 text-primary-700' : 'text-gray-700'
                      } block w-full px-3 py-2 text-left text-sm leading-6 hover:bg-primary-50 hover:text-primary-700 transition-colors`}
                      onClick={() => {
                        // Navigate to profile settings
                        window.location.href = '/settings';
                      }}
                    >
                      Profile
                    </button>
                  )}
                </Menu.Item>
                <Menu.Item>
                  {({ active }) => (
                    <button
                      className={`${
                        active ? 'bg-primary-50 text-primary-700' : 'text-gray-700'
                      } block w-full px-3 py-2 text-left text-sm leading-6 hover:bg-primary-50 hover:text-primary-700 transition-colors`}
                      onClick={logout}
                    >
                      Sign out
                    </button>
                  )}
                </Menu.Item>
              </Menu.Items>
            </Transition>
          </Menu>
        </div>
      </div>
    </div>
  );
};

export default Header;
